(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/streaming-service/assets/javascripts/streaming-service.js') >= 0) return;  svs.modules.push('/components/racing/streaming-service/assets/javascripts/streaming-service.js');

'use strict';

const log = new svs.core.log.Logger('trinidad.racing.stream-service');
const fetchLiveStreamSessionToken = (options, callback) => {
  const businessunit = options && options.businessunit ? options.businessunit : 'RacingOnline';
  const url = "/streaminglauncher/1/launchparameters?businessunit=".concat(businessunit);
  svs.core.jupiter.get(url, response => {
    callback(undefined, {
      sessiontoken: response.data.sessiontoken
    });
  }, error => {
    let message = "Failed getting sessionToken with businessunit ".concat(businessunit, ". ");
    message += "Message: ".concat(error.message);
    log.warn(message);
    callback(error.responseJSON.error);
  });
};
const fetchPlayList = options => {
  const businessunit = options && options.businessunit ? options.businessunit : 'RacingOnline';
  let assetId;
  if (businessunit === 'RacingOnline') {
    assetId = options && options.useLowLatency ? '56e1a9ae_2FA19Eb' : '71d5eb41_2FA19Eb';
  } else {
    assetId = 'EquidiaPro_350701';
  }
  const urlParams = '?assetType=TV_CHANNEL&pageSize=50&pageNumber=1&fieldSet=PARTIAL&onlyPublished=true&includeUserData=false&includeTvShow=false';
  const dfd = jQuery.Deferred();
  const requestUri = "".concat(svs.racing.streaming_service.data.host, "/v1/customer/SvenskaSpel/businessunit/").concat(businessunit, "/content/asset").concat(urlParams).toString('utf8');
  $.getJSON(requestUri).done(result => {
    let liveStream;
    result.items.forEach(element => {
      if (element.assetId === assetId) {
        liveStream = element;
      }
    });
    const thumbnailSrc = getThumbnailFromResult(liveStream);
    const elementModel = {
      thumbnailSrc,
      assetId: liveStream.assetId
    };
    dfd.resolve(elementModel);
  }).catch(error => {
    let message = "Failed getting playlist with assetId ".concat(assetId, ". ");
    message += "Message: ".concat(error.responseText || error.statusText);
    log.warn(message);
    dfd.reject(error);
  });
  return dfd;
};
const getThumbnailFromResult = result => {
  let thumbnail;
  if (result) {
    for (let i = 0; i < result.localized[0].images.length; i++) {
      if (result.localized[0].images[i]) {
        thumbnail = result.localized[0].images[i];
        break;
      }
    }
  }
  return thumbnail && thumbnail.url;
};
svs.racing.streamingService.fetchLiveStreamSessionToken = fetchLiveStreamSessionToken;
svs.racing.streamingService.fetchPlayList = fetchPlayList;

 })(window);